// extracted by mini-css-extract-plugin
export default {"container":"ActivitiesPlaceholder__container___LTq8u","header":"ActivitiesPlaceholder__header___Fz6Wk"};